export default {
  title: 'اپلیکیشن ها',

  labels: {
    appInfo: 'اطلاعات اپلیکیشن',
    planInfo: 'اطلاعات پلن',
    addonsInfo: 'اطلاعات افزودنی ها',
    modulesInfo: 'اطلاعات ماژول ها',
    images: 'تصاویر',
    name: 'نام',
    subdomain: 'آدرس سامانه',
    manager: 'مالک',
    country: 'کشور',
    province: 'استان',
    address: 'آدرس',
    status: 'اپلیکیشن فعال است',
    private: 'اپلیکیشن خصوصی است',
    language: 'زبان',
    timezone: 'منطقه زمانی',
    financialYearStart: 'شروع سال مالی',
    currency: 'واحد پولی',
    supportNumber: 'شماره پشتیبانی',
    email: 'ایمیل',
    maxDebt: 'سقف بدهکاری',
    modules: 'ماژول ها',
    addons: 'افزودنی ها',
    product: 'محصول',
    plan: 'پلن',
    period: 'بازه زمانی ({type})',
    price: 'قیمت',
    totalPrice: 'قیمت کل',
    prevStep: 'مرحله قبل',
    nextStep: 'مرحله بعد',
    createInvoice: 'ایجاد فاکتور',
    pay: 'پرداخت و راه اندازی اپلیکیشن',
    periodPerMonth: ' / {num} ماه',
    delete: 'حذف'
  },

  wizard: {
    generalInfo: {
      label: 'اطلاعات کلی',
      description: 'اطلاعات کلی اپلیکیشن'
    },
    product: {
      label: 'محصول',
      description: 'انتخاب محصول'
    },
    plan: {
      label: 'پلن',
      description: 'انتخاب پلن'
    },
    module: {
      label: 'ماژول',
      description: 'انتخاب ماژول'
    },
    addon: {
      label: 'افزودنی',
      description: 'انتخاب افزودنی'
    },
    checkout: {
      label: 'تایید نهایی',
      description: 'تایید نهایی'
    },
  },

  table: {
    header: {
      select: 'انتخاب',
      row: 'ردیف',
      logo: 'لوگو',
      date: 'تاریخ ایجاد',
      name: 'نام',
      product: 'محصول',
      manager: 'مالک',
      city: 'شهر',
      province: 'استان',
      country: 'کشور',
      supportNumber: 'تلفن پشتیبانی',
      email: 'ایمیل',
      maxDebt: 'سقف بدهکاری',
      balance: 'موجودی',
      status: 'وضعیت',
      private: 'خصوصی',
      type: 'نوع',
      publicId: 'شناسه عمومی',
      expireDate: 'تاریخ انقضاء',
      delete: 'حذف',
      restore: 'بازگردانی'
    }
  },

  notifications: {
    wrongInputValue: 'فیلدهای وارد شده صحیح نیستند',

    insert: {
      success: 'اپلیکیشن با موفقیت ایجاد شد',
      error: 'افزودن اپلیکیشن با خطا همراه شد'
    },

    createInvoice: {
      success: 'فاکتور اپلیکیشن با موفقیت ایجاد شد',
      error: 'افزودن فاکتور اپلیکیشن با خطا همراه شد'
    },

    edit: {
      success: 'اپلیکیشن با موفقیت ویرایش شد',
      error: 'ویرایش اپلیکیشن با خطا همراه شد'
    },

    maxDebt: {
      success: 'اپلیکیشن با موفقیت ویرایش شد',
      error: 'ویرایش اپلیکیشن با خطا همراه شد'
    },

    deploy: {
      error: 'راه اندازی سامانه اپلیکیشن با خطا همراه شد'
    },

    enable: {
      success: 'اپلیکیشن با موفقیت فعال شد',
      error: 'فعال شدن اپلیکیشن با خطا همراه شد'
    },

    disable: {
      success: 'اپلیکیشن با موفقیت غیرفعال شد',
      error: 'غیرفعال شدن اپلیکیشن با خطا همراه شد'
    },

    delete: {
      success: 'اپلیکیشن با موفقیت حذف شد',
      error: 'حذف اپلیکیشن با خطا همراه شد'
    },

    restore: {
      success: 'اپلیکیشن با موفقیت بازگردانی شد',
      error: 'بازگردانی اپلیکیشن با خطا همراه شد'
    },

    parseError: {
      name: 'نام سامانه معتبر نیست یا قبلا انتخاب شده است',
      subdomain: 'آدرس سامانه معتبر نیست یا قبلا انتخاب شده است',
      sport: 'آدرس سامانه معتبر نیست یا قبلا انتخاب شده است',
      supportNumber: 'شماره پشتیبانی معتبر نیست یا قبلا انتخاب شده است'
    }
  },

  validators: {
    subdomain: 'آدرس سامانه باید انگلیسی باشد',
    subdomainNumber: 'آدرس سامانه نمیتواند با عدد شروع شود',
    subdomainExist: 'آدرس وارد شده قبلا رزرو شده است',
    illegalSubdomain: 'آدرس وارد شده مجاز نیست و یا قبلا رزرو شده است'
  },

  confirmations: {
    delete: {
      title: 'تاییدیه حذف اپلیکیشن',
      body: 'آیا از حذف اپلیکیشن مورد نظر اطمینان دارید؟'
    },

    deploy: {
      title: 'تاییدیه راه اندازی اپلیکیشن',
      body: 'ایا از راه اندازی اپلیکیشن مورد نظر اطمینان دارید؟'
    },

    routeBack: {
      title: 'لغو عملیات افزودن اپلیکیشن',
      body: 'اگر این صفحه را ترک کنید، تمامی اطلاعات وارد شده شما از بین خواهد رفت. آیا از لغو کردن افزودن اپلیکیشن اطمینان دارید؟'
    },

    changeStatus: {
      title: 'تاییدیه تغییر وضعیت اپلیکیشن',
      body: 'ایا از تغییر وضعیت اپلیکیشن مورد نظر اطمینان دارید؟'
    }
  },

  statusTypes: {
    all: 'همه',
    signup: 'ثبت نام',
    created: 'ایجاد شده',
    pending: 'در انتظار پرداخت',
    deploying: 'در حال راه اندازی',
    active: 'فعال',
    expired: 'منقضی شده',
    upgrade: 'در حال بروزرسانی',
    suspend: 'بلاک شده'
  },

  privateTypes: {
    private: 'خصوصی',
    public: 'عمومی'
  },

  products: {
    accounting: {
      title: 'حسابداری',
      description: ''
    },
    booking: {
      title: 'رزرواسیون',
      description: ''
    }
  },

  list: {
    title: 'اپلیکیشن ها'
  },

  trash: {
    title: 'سطل زباله اپلیکیشن ها'
  },

  insert: {
    title: 'افزودن اپلیکیشن جدید'
  },

  edit: {
    title: 'ویرایش اپلیکیشن',
    dynamicTitle: 'ویرایش {name}'
  },

  profile: {
    title: 'پروفایل اپلیکیشن',
    dynamicTitle: 'پروفایل {name}',

    importantData: {
      manager: 'مدیریت',
      status: 'وضعیت',
      private: 'خصوصی',
      publicId: 'شناسه عمومی',
      balance: 'موجودی',
      maxDebt: 'سقف بدهکاری'
    },

    actions: {
      dashboard: 'داشبورد',
      subscription: 'اشتراک ها',
      maxDebt: 'سقف بدهکاری',
      showTransactions: 'گردش مالی',
      appRequests: 'درخواست ها',
      appReceives: 'دریافت ها',
      paymentMethods: 'روش های پرداخت',
      invoices: 'فاکتورهای فروش',
      refundInvoices: 'فاکتورهای مرجوعی',
      clubLogin: 'ورود به پنل',
      appDeploy: 'راه اندازی سامانه',
      employees: 'کارکنان',
      suspend: 'تعلیق',
      unsuspend: 'لغو تعلیق',
      logs: 'لیست لاگ ها'
    }
  },

  requests: {
    title: 'درخواست های اپلیکیشن',

    labels: {
      department: 'دپارتمان',
      type: 'نوع',
      status: 'وضعیت',
      details: 'جزئیات',
      answer: 'پاسخ',
      reject: 'رد درخواست',
      accept: 'تایید'
    },

    table: {
      header: {
        row: 'ردیف',
        date: 'تاریخ',
        department: 'دپارتمان',
        details: 'جزئیات',
        type: 'نوع',
        status: 'وضعیت'
      }
    },

    departmentOptions: {
      all: 'همه',
      1: 'فنی',
      2: 'مالی'
    },

    typeOptions: {
      all: 'همه',
      1: 'بروزرسانی اطلاعات اپلیکیشن'
    },

    statusOptions: {
      all: 'همه',
      0: 'ایجاد شده',
      1: 'در حال بررسی',
      2: 'تایید شده',
      3: 'رد شده'
    },

    notifications: {
      emptyAnswer: 'پاسخی برای درخواست وارد نشده است',

      reject: {
        success: 'درخواست اپلیکیشن با موفقیت رد شد',
        error: 'رد شدن درخواست اپلیکیشن با خطا همراه شد'
      },

      confirm: {
        success: 'درخواست اپلیکیشن با موفقیت پذیرفته شد',
        error: 'پذیرفتن درخواست اپلیکیشن با خطا همراه شد'
      }
    },

    list: {
      title: 'لیست درخواست های اپلیکیشن'
    },

    profile: {
      title: 'درخواست اپلیکیشن'
    },

    clubInfo: {
      title: 'اطلاعات اپلیکیشن',

      labels: {
        generalInfo: 'اطلاعات عمومی',
        name: 'نام',
        locale: 'موقعیت مکانی',
        onlineBooking: 'قابلیت رزرو آنلاین دارد',
        telInfo: 'اطلاعات تماس',
        province: 'استان',
        city: 'شهر',
        address: 'آدرس',
        supportNumber: 'شماره پشتیبانی',
        email: 'ایمیل'
      }
    }
  },

  receives: {
    title: 'دریافت های اپلیکیشن',

    list: {
      title: 'دریافت های اپلیکیشن',
    }
  },

  invoices: {
    title: 'فاکتورهای اپلیکیشن'
  },

  refundInvoices: {
    title: 'فاکتورهای مرجوعی اپلیکیشن'
  },

  employees: {
    title: 'کارمندان اپلیکیشن',

    labels: {
      user: 'کاربر',
      owner: 'مالک'
    },

    notifications: {
      noUserSelected: 'کاربری انتخاب نشده است',
      insert: {
        success: 'کارمند با موفقیت ایجاد شد',
        error: 'ایجاد کارمند با خطا همراه شد'
      },
      delete: {
        success: 'کارمند با موفقیت حذف شد',
        error: 'حذف کارمند با خطا همراه شد'
      },
      suspend: {
        success: 'کارمند با موفقیت غیرفعال شد',
        error: 'غیرفعال شدن کارمند با خطا همراه شد'
      },
      active: {
        success: 'کارمند با موفقیت فعال شد',
        error: 'فعال شدن کارمند با خطا همراه شد'
      }
    },

    confirmations: {
      delete: {
        title: 'تاییدیه حذف کارمند',
        body: 'آیا از حذف کارمند مورد نظر اطمینان دارید؟'
      },
      active: {
        title: 'تاییدیه عال کردن کارمند',
        body: 'آیا از فعال کردن کارمند مورد نظر اطمینان دارید؟'
      },
      suspend: {
        title: 'تاییدیه غیرفعال کردن کارمند',
        body: 'آیا از غیرفعال کردن کارمند مورد نظر اطمینان دارید؟'
      },
    },

    insert: {
      title: 'افزودن کارمند'
    }
  },

  deploy: {
    title: 'راه اندازی سامانه',
    dynamicTitle: 'راه اندازی اپلیکیشن {name}',

    description: 'برای راه اندازی اپلیکیشن بر روی راه اندازی اپلیکیشن کلیک کنید',

    labels: {
      codeValidate: 'اعتبار کد تا ',
      second: 'ثانیه',
    },

    steps: {
      request_created: 'درخواست ایجاد شد',
      subdomain_created: 'ساب دامنه ایجاد شد',
      database_created: 'دیتابیس ایجاد شد',
      environment_created: 'پیکره بندی ایجاد شد',
      database_migrated: 'پایگاه داده منتقل شد',
      database_seeded: 'پایگاه داده مقداردهی اولیه شد',
      supervisor_created: 'ادمین ساخته شد',
      deployed: 'اپلیکیشن راه اندازی شد'
    },

    notifications: {
      success: {
        title: 'اپلیکیشن {name} با موفقیت راه اندازی شد',
        body: 'جهت ورود به پنل مدیریت این اپلیکیشن، روی دکمه زیر کلیک کنید'
      },
      parseError: {
        hasDeployed: 'پنل مدیریت این اپلیکیشن قبلا راه اندازی شده است'
      }
    },

    sendOtp: {
      title: 'تاییدیه ورود به اپلیکیشن',
      text: 'کد تایید ورود به اپلیکیشن ارسال شده است. لطفا کد را وارد کنید'
    },

    actions: {
      deploy: 'راه اندازی سامانه',
      goToClub: 'ورود به پنل'
    }
  },

  transactions: {
    title: 'گردش مالی اپلیکیشن',
    dynamicTitle: 'گردش مالی',
    documentTitle: 'سند گردش مالی اپلیکیشن',

    table: {

      header: {
        docNumber: 'شماره سند',
        date: 'تاریخ',
        documentation: 'مستندات',
        price: 'مبلغ',
        balance: 'موجودی'
      }
    },

    types: {
      sale: 'فروش',
      receive: 'دریافت'
    }
  },

  dashboard: {
    title: 'داشبورد اپلیکیشن',

    labels: {
      status: 'وضعیت',
      tickets: 'تیکت ها',
      documents: 'اسناد',
      activeUsers: 'کاربران فعال',
      active: 'فعال',
      disable: 'غیرفعال',
      dynamicDayRemaining: '{num} روز باقی مانده | {num} روز باقی مانده | {num} روز باقی مانده'
    }
  },

  paymentMethods: {
    title: 'روش های پرداخت اپلیکیشن',

    labels: {
      autoPayment: 'پرداخت خودکار',
      title: 'عنوان',
      cardNumber: 'شماره کارت',
      cvv2: 'CVV2',
      expireDate: 'تاریخ انقضاء'
    },

    table: {
      header: {
        row: 'ردیف',
        title: 'عنوان',
        date: 'تاریخ',
        expireDate: 'تاریخ انقضاء',
        cardNumber: 'شماره کارت',
        autoPayment: 'پرداخت خودکار',
        action: 'اکشن ها'
      }
    },

    notifications: {
      setAutoPayment: 'پرداخت خودکار برای روش پرداخت دیگری فعال است.',

      insert: {
        success: 'روش پرداخت با موفقیت ایجاد شد',
        error: 'افزودن روش پرداخت با خطا همراه شد'
      },
      edit: {
        success: 'روش پرداخت با موفقیت ویرایش شد',
        error: 'ویرایش روش پرداخت با خطا همراه شد'
      },
      delete: {
        success: 'روش پرداخت با موفقیت حذف شد',
        error: 'حذف روش پرداخت با خطا همراه شد'
      },
      parseError: {
        cardNumber: 'شماره کارت معتبر نیست',
        expireDate: 'تاریخ انقضاء کارت معتبر نیست'
      }
    },

    confirmations: {
      autoPayment: {
        title: 'تاییدیه پرداخت خودکار',
        body: 'قبلا پرداخت خودکار برای روش پرداخت دیگری فعال شده است. ایا از فعال کردن پرداخت خودوکار اطمینان دارید؟'
      },
      delete: {
        title: 'تاییدیه حذف روش پرداخت',
        body: 'آیا از حذف روش پرداخت مورد نظر اطمینان دارید؟'
      },
    },

    list: {
      title: 'روش های پرداخت اپلیکیشن'
    },

    insert: {
      title: 'افزودن روش پرداخت اپلیکیشن'
    },

    edit: {
      title: 'ویرایش روش پرداخت اپلیکیشن'
    }
  },

  maxDebt: {
    title: 'سقف بدهکاری اپلیکیشن',
    dynamicTitle: 'سقف بدهکاری {name}'
  },

  logs: {
    title: 'لاگ های اپلیکیشن'
  }
}
